import { TimeCard } from '../../../../api/models/timecard.model'
import { Utils } from '../../../common/utils/utils'

export class TimeCardRep {
    domId: string
    timeCard: TimeCard
    assembledText: string
    hoursToInvoice: string
    hoursNoInvoice: string

    constructor(timeCard: TimeCard, detailed: boolean, showPriority: boolean, viewByTag: boolean | undefined) {
        this.timeCard = timeCard
        let worklogComment = this.timeCard.worklogComment
        if (!viewByTag) {
            worklogComment = Utils.removeAllTagsFromText(worklogComment, timeCard.date > new Date(2023, 3, 20))
        }
        this.domId = `TIMECARDREP-ID-${timeCard.id}`
        this.hoursToInvoice = Utils.secondsAsHours(this.timeCard.secondsToInvoice)
        this.hoursNoInvoice = Utils.secondsAsHours(this.timeCard.secondsNoInvoice)
        this.assembledText =
            (showPriority && timeCard.issuePriority ? `Priority =  ${timeCard.issuePriority}: ` : '') +
            ((detailed || viewByTag) && worklogComment
                ? `${timeCard.issueTitle}: ${worklogComment}`
                : timeCard.issueTitle)
    }
}
